import {ErrorHandler, NgModule} from '@angular/core';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {AppLayoutModule} from './layout/app.layout.module';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ButtonModule} from 'primeng/button';
import {CardModule} from 'primeng/card';
import {BrowserModule} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {ApiInterceptor} from './helpers/api-interceptor';
import {CheckoutModalComponent} from './components/checkout/checkout.component';
import {DialogService} from 'primeng/dynamicdialog';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DialogModule} from 'primeng/dialog';
import {FooterComponent} from './components/footer/footer.component';
import {ToastrModule} from 'ngx-toastr';
import {UpgradeModule} from './components/upgrade/upgrade.module';
import {ParamAwareReuseStrategy} from './helpers/param-reuse.strategy';
import {RouteReuseStrategy} from '@angular/router';
import {WaitlistBannerComponent} from './components/waitlist-banner/waitlist-banner.component';
import * as Sentry from "@sentry/angular";

@NgModule({
    declarations: [
        AppComponent,
        CheckoutModalComponent,
        FooterComponent,
    ],
    imports: [
        AppRoutingModule,
        AppLayoutModule,
        UpgradeModule,
        BrowserModule,
        BrowserAnimationsModule,
        ButtonModule,
        CardModule,
        ReactiveFormsModule,
        DialogModule,
        FormsModule,
        HttpClientModule,
        ToastrModule.forRoot({
            positionClass: 'toast-bottom-right',
            toastClass: 'toast-container ngx-toastr'
        }),
        WaitlistBannerComponent,
    ],
    providers: [
        DialogService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true,
        },
        { provide: RouteReuseStrategy, useClass: ParamAwareReuseStrategy },
        {
            provide: ErrorHandler,
            useFactory: () => Sentry.createErrorHandler({ showDialog: false }),
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
